import { render, staticRenderFns } from "./OwnersNewsletter.vue?vue&type=template&id=ec8d43de&scoped=true&"
import script from "./OwnersNewsletter.vue?vue&type=script&lang=js&"
export * from "./OwnersNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./OwnersNewsletter.vue?vue&type=style&index=0&id=ec8d43de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8d43de",
  null
  
)

export default component.exports